// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2_9lb","rootSmall":"AddTileButton_rootSmall__34ztt"};